// ./src/lib/Auth.js

import Storage from './Storage';

const key = 'game-key';

const Auth = {
  /**
   * @returns {(string|null)} stored token or null
   */
  getAuth() {
    return Storage.get(key);
  },

  /**
   *
   * @param {string} token
   *
   * @returns {void}
   */
  setAuth(token) {
    Storage.set(key, token);
  },

  /**
   * @returns {void}
   */
  removeAuth() {
    Storage.remove(key);
  },
};

export default Auth;
